import { colors, TableHeading } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableHeadingStyled = styled(TableHeading)`
  background-color: ${colors.neutral[200]};
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: center;
  padding: 1.8rem 2.4rem;
  border-top: 0.2rem solid ${colors.neutral[400]};
  border-bottom: 0.2rem solid ${colors.neutral[400]};
  border-left: 0.05rem solid ${colors.neutral[300]};
`;

export const TableHeadingNumberStyled = styled(TableHeading)`
  width: 1.5rem;
  box-sizing: border-box;
  padding: 1.8rem 1.2rem;
  font-weight: 700;
  text-align: center;
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: ${colors.neutral[200]};

  /* Match first table cell styles */
  border-top: 0.2rem solid ${colors.neutral[400]};
  border-bottom: 0.2rem solid ${colors.neutral[400]};
  border-left: 0.05rem solid transparent;
  border-right: 0.05rem solid ${colors.neutral[300]};

  &::after {
    position: absolute;
    content: '';
    inset: 0;
    border-right: 2px solid ${colors.neutral[300]};
  }
`;
